import { HugeiconsIcon } from '@hugeicons/react'
import { ClosedCaptionAltIcon } from '@hugeicons/core-solid-rounded'
import * as Popover from '@radix-ui/react-popover'
import { useLingui } from '@lingui/react/macro'

import Input from '@/components/ui/Input'
import { popoverContainer } from '@/utils/popovers'
import Field from '@/components/ui/Field'

interface Props {
  value?: string | null
  onChange: (altText: string) => void
}

export default function AltTextPopover({ value, onChange }: Props) {
  const { t } = useLingui()

  return (
    <Popover.Root>
      <Popover.Trigger
        className="rounded bg-black/50 p-1 text-white outline-primary hover:bg-black/70"
        aria-label={t`Edit Alt text`}
        title={t`Edit Alt text`}
      >
        <HugeiconsIcon icon={ClosedCaptionAltIcon} className="size-full" />
      </Popover.Trigger>
      <Popover.Portal container={popoverContainer}>
        <Popover.Content
          side="top"
          collisionPadding={20}
          sideOffset={5}
          className="relative overflow-hidden rounded bg-white shadow-xl z-popover p-3 max-w-[600px]"
        >
          <Field
            label={t`Alt text`}
            description={t`The alt text is a short description of what an image shows. They are used by screen readers to help visually impaired users. (This is required in Europe under the Accessibility Act)`}
          >
            <Input
              type="text"
              value={value ?? ''}
              placeholder={t`example: A woman enjoying a massage.`}
              onChange={event => onChange(event.target.value)}
            />
          </Field>
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  )
}
